<template>
  <div>
    <appHeader></appHeader>
    <transition appear name="fade">
      <div class="container">
        <br><br>
        <appProductGrid></appProductGrid>
      </div>
    </transition>
    <appFooter></appFooter>
  </div>
</template>

<script>

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import ProductGrid from './ProductGrid.vue'

export default {
  data () {
    return {}
  },
  computed: {},
  components: {
    appHeader: Header,
    appFooter: Footer,
    appProductGrid: ProductGrid,
  },
  methods: {},
  created () {}
}
</script>

<style lang="scss" scoped>
.custom-filter{
  width: 250px;
  select{
    max-width: 160px;
  }
}
@media all and (max-width: 480px){
  .filters-row{
    display: none;
  }
}
</style>
